module.exports = __webpack_public_path__ + "static/media/grey_marker_icon.66f4fd33.svg";